interface MyTeamsState {
  viewTeams: any[];
  coachId: string | null;
  filters: any;
  sortParams: any;
  reportFilterCount: number;
  reportCountAllOrg: number;
}

export default (
  state: MyTeamsState = {
    viewTeams: [],
    coachId: null,
    filters: {},
    sortParams: {},
    reportFilterCount: 0,
    reportCountAllOrg: 0,
  },
  action: any,
): MyTeamsState => {
  const {
    coachId,
    myTeams = [],
    filters,
    sortParams,
    reportFilterCount,
    reportCountAllOrg,
    appendData = false,
  } = action;

  const incomingCoachId = coachId != null ? String(coachId) : null;
  const currentCoachId = state.coachId != null ? String(state.coachId) : null;

  const isSameCoach = incomingCoachId === currentCoachId;
  const shouldAppend = appendData && isSameCoach;

  const existingData = state.viewTeams;

  let mergedData = [];

  if (shouldAppend) {
    // Safe pagination
    const combined = [...existingData, ...myTeams];

    mergedData = combined.filter(
      (v, i, arr) =>
        arr.findIndex(item => String(item.id) === String(v.id)) === i,
    );
  } else {
    // New coach OR refresh
    mergedData = myTeams;
  }

  return {
    ...state,

    //always overwrite coachId
    coachId: incomingCoachId,

    //only one coach data stored
    viewTeams: mergedData,

    //overwrite (since single coach mode)
    filters: {
      ...state.filters,
      [coachId]: filters,
    },
    sortParams: {
      ...state.sortParams,
      [coachId]: sortParams,
    },

    //keep latest counts
    reportFilterCount,
    reportCountAllOrg,
  };
};
